import { put, select, takeLatest } from 'redux-saga/effects'
import { PatientDemographicsConstants } from '../../patientDemographics/store/patientDemographics.constants'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getPatientDemographicsSelector } from '../../patientDemographics/selectors'
import { IPatientDemographicsState } from '../../patientDemographics/store/patientDemographics.types'
import { setPatientSearchData as setPatientSearchDataAction } from '../store/patientSearch.actions'
import { getLast4SNN } from '../../../utilities/ssn.util'
import { PatientSearchConstants } from '../store/patientSearch.constants'
import { IRulesState } from '../../rules/store/rules.types'
import { getRulesSelector } from '../../rules/selectors'
import { clearValidationErrorsByPathList } from '../../../utilities/runRulesValidation.util'

export function* setPatientSearchData() {
  const rules: IRulesState = yield select(getRulesSelector)
  const patientDemographicsState: IPatientDemographicsState = yield select(getPatientDemographicsSelector)
  const { firstName, lastName, sSN, dOB, dnr } = patientDemographicsState

  rules.errors = clearValidationErrorsByPathList(rules.errors, ['patientSearch'])
  yield put(setPatientSearchDataAction({ firstName, lastName, dOB, dnr, sSN: getLast4SNN(sSN) }))
}

export function* setPatientSearchDataSaga() {
  yield takeLatest(
    [
      PatientSearchConstants.GET_PATIENT_SEARCH_DATA,
      PatientDemographicsConstants.SET_FIRST_NAME,
      PatientDemographicsConstants.SET_LAST_NAME,
      PatientDemographicsConstants.SET_DOB,
      PatientDemographicsConstants.SET_SSN,
      PatientDemographicsConstants.SET_PATIENT_DEMOGRAPHICS,
    ],
    performWithMutexHOG,
    setPatientSearchData
  )
}
